import React from 'react';
import PhoneInput from 'react-phone-input-2';
import { useField, useFormikContext } from 'formik';
import cn from 'classnames';

import InputError from 'components/InputsField/InputError';
import Label from 'components/InputsField/Label';

import styles from './styles.module.scss';

// TODO improved it
import 'react-phone-input-2/lib/style.css';

const DEFAULT_COUNTRY = 'ru';

const PhoneField = ({ label, required, name, onTouch, wrapperClass, errorMode, ...props }) => {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();

  const handleChange = (phone) => {
    setFieldValue(name, phone);
    onTouch(name, true);
  };

  return (
    <div className={cn(styles.wrapper, wrapperClass)}>
      {label && <Label name={name} label={label} required={required} />}
      <PhoneInput
        inputProps={{
          id: name,
        }}
        value={field.value}
        onChange={handleChange}
        inputClass={styles.input}
        country={DEFAULT_COUNTRY}
        containerClass={styles.wrapperField}
        buttonClass={styles.button}
        {...props}
      />
      {meta.touched && meta.error && <InputError message={meta.error} mode={errorMode || 'top-right'} />}
    </div>
  );
};

export default PhoneField;
